import Vue from 'vue';
import Vuex from 'vuex';
import pathify from 'vuex-pathify';

Vue.use(Vuex);

function getImportedModules(r) {
  return r.keys().reduce((modules, key) => {
    modules[
      key
        .split(/[\\/]/)
        .pop()
        .replace(/\.[^.]+$/, '')
    ] = r(key).default;
    return modules;
  }, {});
}

let mainStores = getImportedModules(require.context('@/store/', false, /^(?!.*index).*\.js$/));
/**
 * V2 stores only work with VUE_APP_API_V2_URL env variable provided with VUE_APP_USE_V2 set to true.
 *
 * A loop below assumes that there is at least one action in V2 store.
 * Every V2 store must have the name of a existing store in current modules set.
 * If an existing action from any store is supposed to be overwritten,
 * new V2 action must have it's exact same name and be placed in a store with corresponding name.
 * e.g. store/v2/layers/getTile will overwrite store/layers/getTile action.
 *
 * Custom mutations are also supported on demand.
 */
if (process.env.VUE_APP_USE_V2 === 'true' && process.env.VUE_APP_API_V2_URL) {
  const v2Stores = getImportedModules(require.context('@/store/v2', false, /\.js$/));
  Object.entries(v2Stores).forEach(([storeName, moduleData]) => {
    let mainModuleData = mainStores[storeName];
    if (!mainModuleData) return;
    mainStores[storeName] = {
      ...mainModuleData,
      actions: {
        ...mainModuleData.actions,
        ...moduleData.actions,
      },
      ...(moduleData.mutations && { mutations: { ...mainModuleData.mutations, ...moduleData.mutations } }),
    };
  });
}

export default new Vuex.Store({
  plugins: [pathify.plugin],
  strict: process.env.NODE_ENV !== 'production',
  modules: mainStores,
});
